import {AbstractControl, ValidatorFn} from '@angular/forms';

import {InArrayValidatorKey} from './custom-validator-keys';

export function InArrayValidator(array: (number | string)[]): ValidatorFn {
    return (control: AbstractControl): { [InArrayValidatorKey]: boolean } | null => {
        if (control.value) {
            return (array.indexOf(control.value) < 0) ? {[InArrayValidatorKey]: true} : null;
        }

        return null;
    };
}
